export default __webpack_public_path__ + "static/media/gtheright.de7c37f1.png";